import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  Globe,
  Bell,
  Mail,
  Lock
} from 'lucide-react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/screens/customer/dashboard/settings/Settings.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';

const Toggle = ({ on, onChange }) => (
  <button
    type="button"
    className={`stg-toggle ${on ? 'stg-toggle--on' : ''}`}
    onClick={() => onChange(!on)}
  >
    <span className="stg-toggle__thumb" />
  </button>
);

const CustomerSettings = () => {
  const navigate = useNavigate();
  const [push_notification, setPush_notification] = useState(false);
  const [email_notification, setEmail_notification] = useState(false);
  const { baseUrl, RegExpChecker } = useContext(AppContext);  // const [language, setLanguage] = useState('English');
  // const [showLangPicker, setShowLangPicker] = useState(false);
const [loading, setLoading] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });


  // const LANGUAGES = [
  //   'English',
  //   'Urdu',
  //   'Arabic',
  //   'French',
  //   'Spanish'
  // ];

  const view = () => {
    axios.get(
      `${baseUrl}/customer/setting`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
        }
      }
    )
      .then((res) => {

        const data = res.data.setting;

        setPush_notification(data.push_notification);
        setEmail_notification(data.email_notification);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  //update
  const updateSetting = (
    notificationValue = push_notification,
    emailValue = email_notification
  ) => {

    const formData = new FormData();

    formData.append('push_notification', notificationValue ? 1 : 0);
    formData.append('email_notification', emailValue ? 1 : 0);

    axios.post(
      `${baseUrl}/customer/update/setting`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
        }
      }
    )
      .then((res) => {


      })
      .catch((error) => {

        console.log("Full Error:", error);
        console.log("Response:", error.response);
        console.log("Data:", error.response?.data);

        alert("Error");
      });
  };


  const handleUpdatePassword = async () => {

    let validationErrors = {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };

    let hasError = false;

    if (!passwordData.currentPassword.trim()) {
      validationErrors.currentPassword = "Current password is required.";
      hasError = true;
    }

    if (!passwordData.newPassword.trim()) {
      validationErrors.newPassword = "New password is required.";
      hasError = true;
    } else {
      const check = RegExpChecker("password", passwordData.newPassword);

      if (check.password) {
        validationErrors.newPassword = check.password;
        hasError = true;
      }
    }

    if (!passwordData.confirmPassword.trim()) {
      validationErrors.confirmPassword = "Confirm password is required.";
      hasError = true;
    }
    else if (
      passwordData.newPassword !==
      passwordData.confirmPassword
    ) {
      validationErrors.confirmPassword =
        "Passwords do not match.";
      hasError = true;
    }

    setErrors(validationErrors);

    setLoading(true);

    try {

      const res = await axios.post(
        `${baseUrl}/customer/updatepassword`,
        {
          current_password: passwordData.currentPassword,
          new_password: passwordData.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (res.data.success) {
localStorage.setItem(
  "customer",
  JSON.stringify(res.data.customer)
);

localStorage.setItem(
  "password",
  res.data.customer.password
);
        setPasswordData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });

        setErrors({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });

        setShowPasswordModal(false);

      } else {

        setErrors({
          ...validationErrors,
          currentPassword: res.data.message,
        });

      }

    } catch (err) {

      setErrors({
        ...validationErrors,
        currentPassword:
          err.response?.data?.message || "Something went wrong.",
      });

    }

  };


  useEffect(() => {
    view();
  }, []);

  return (
    <>
      <AppNavbar />

      <div className="stg-page">

        {/* Header */}
        <div className="stg-header">
          <button className="stg-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>

          <h2 className="stg-title">Settings</h2>
        </div>

        <div className="stg-body">

          {/* Language */}
          {/* <div
            className="stg-card"
            onClick={() => setShowLangPicker(true)}
          >
            <div
              className="stg-card__icon"
              style={{
                background: 'rgba(4,145,225,0.10)',
                color: '#0491e1'
              }}
            >
              <Globe size={20} />
            </div>

            <div className="stg-card__info">
              <span className="stg-card__label">Language</span>
              <span className="stg-card__sub">{language}</span>
            </div>
          </div> */}

          {/* Push Notifications */}
          <div className="stg-card">
            <div
              className="stg-card__icon"
              style={{
                background: 'rgba(4,145,225,0.10)',
                color: '#0491e1'
              }}
            >
              <Bell size={20} />
            </div>

            <div className="stg-card__info">
              <span className="stg-card__label">
                Push Notifications
              </span>
              <span className="stg-card__sub">
                Receive app notifications
              </span>
            </div>

            <Toggle
              on={push_notification}
              onChange={(value) => {
                setPush_notification(value);
                updateSetting(value, email_notification);
              }}
            />
          </div>

          {/* Email Notifications */}
          {/* <div className="stg-card">
            <div
              className="stg-card__icon"
              style={{
                background: 'rgba(76,175,80,0.10)',
                color: '#4caf50'
              }}
            >
              <Mail size={20} />
            </div>

            <div className="stg-card__info">
              <span className="stg-card__label">
                Email Notifications
              </span>
              <span className="stg-card__sub">
                Receive updates by email
              </span>
            </div>

            <Toggle
              on={email_notification}
              onChange={(value) => {
                setEmail_notification(value);
                updateSetting(push_notification, value);
              }}
            />
          </div> */}

          {/* Change Password */}
          {/* Change Password */}
          <div
            className="stg-card"
            onClick={() => setShowPasswordModal(true)}
          >
            <div
              className="stg-card__icon"
              style={{
                background: 'rgba(255,152,0,0.10)',
                color: '#ff9800'
              }}
            >
              <Lock size={20} />
            </div>

            <div className="stg-card__info">
              <span className="stg-card__label">
                Change Password
              </span>

              <span className="stg-card__sub">
                Update your account password
              </span>
            </div>
          </div>


        </div>

        {/* Language Modal */}
        {/* {showLangPicker && (
          <div
            className="stg-overlay"
            onClick={() => setShowLangPicker(false)}
          >
            <div
              className="stg-sheet"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="stg-sheet__handle" />

              <h3 className="stg-sheet__title">
                Select Language
              </h3>

              {LANGUAGES.map((lang) => (
                <button
                  key={lang}
                  className={`stg-sheet__item ${
                    language === lang
                      ? 'stg-sheet__item--active'
                      : ''
                  }`}
                  onClick={() => {
                    setLanguage(lang);
                    setShowLangPicker(false);
                  }}
                >
                  {lang}

                  {language === lang && (
                    <span className="stg-sheet__check">
                      ✓
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        )} */}
      </div>
      {showPasswordModal && (
        <div
          className="stg-overlay"
          onClick={() => setShowPasswordModal(false)}
        >
          <div
            className="stg-password-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="stg-password-title">
              Change Password
            </h3>

            <div className="stg-password-group">
              <label>Current Password</label>

              <input
                type="password"
                placeholder="Enter current password"
                value={passwordData.currentPassword}
                onChange={(e) => {
                  setPasswordData({
                    ...passwordData,
                    currentPassword: e.target.value
                  });

                  setErrors({
                    ...errors,
                    currentPassword: ""
                  });
                }}
              />
              {errors.currentPassword && (
  <span className="stg-input-error">
    {errors.currentPassword}
  </span>
)}
            </div>

            <div className="stg-password-group">
              <label>New Password</label>

              <input
                type="password"
                placeholder="Enter new password"
                value={passwordData.newPassword}
                onChange={(e) => {
                  setPasswordData({
                    ...passwordData,
                    newPassword: e.target.value
                  });

                  setErrors({
                    ...errors,
                    newPassword: ""
                  });
                }}
                
              />
              {errors.newPassword && (
  <span className="stg-input-error">
    {errors.newPassword}
  </span>
)}
            </div>
            <div className="stg-password-group">
              <label>Confirm Password</label>

              <input
                type="password"
                placeholder="Confirm new password"
                value={passwordData.confirmPassword}
                onChange={(e) => {
                  setPasswordData({
                    ...passwordData,
                    confirmPassword: e.target.value
                  });

                  setErrors({
                    ...errors,
                    confirmPassword: ""
                  });
                }}
              />
              {errors.confirmPassword && (
  <span className="stg-input-error">
    {errors.confirmPassword}
  </span>
)}
            </div>

            <div className="stg-password-actions">
              <button
                className="stg-cancel-btn"
                onClick={() => setShowPasswordModal(false)}
              >
                Cancel
              </button>

              <button
                className="stg-save-btn"
                onClick={handleUpdatePassword}
              >
                Update Password
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerSettings;